module.exports = __webpack_public_path__ + "img/identificationActiveNg.74562d89.svg";